const NodeEnvs = {
  DEV: 'dev',
  LOCAL: 'local',
  PROD: 'prod',
  TEST: 'test',
  DEVELOPMENT: 'development',
};

export default NodeEnvs;
